
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import ProfileMenu from "@/components/ProfileMenu";
import { User } from "@supabase/supabase-js";

interface AuthLinksProps {
  user: User | null;
  isLoading: boolean;
}

const AuthLinks = ({ user, isLoading }: AuthLinksProps) => {
  const location = useLocation();
  const isPasswordResetFlow =
    location.pathname === "/nova-senha" &&
    sessionStorage.getItem("password_reset_in_progress") === "true";

  // Hide auth buttons on simulation pages
  const hideAuthButtons = [
    '/resultados-busca',
    '/infos-festa'
  ].includes(location.pathname);

  if (hideAuthButtons && !user) {
    return null;
  }
  return (
    <div className="hidden md:flex items-center gap-4">
      {isLoading ? (
        <div className="h-10 w-10 rounded-full bg-accent animate-pulse"></div>
      ) : user && !isPasswordResetFlow ? (
        <ProfileMenu />
      ) : (
        <>
          <Link to="/login?from=home" className="text-foreground hover:text-primary transition-colors text-sm font-medium">
            Entrar
          </Link>
          <Button asChild className="bg-[#eefda3] text-brand-dark hover:bg-[#eefda3]/90 rounded-full px-5">
            <Link to="/cadastro-fornecedor">Agendar demonstração</Link>
          </Button>
        </>
      )}
    </div>
  );
};

export default AuthLinks;
